import { render, staticRenderFns } from "./CaseTektronix.vue?vue&type=template&id=2aed2456&lang=pug"
import script from "./CaseTektronix.vue?vue&type=script&lang=js"
export * from "./CaseTektronix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports